import { Component, useEffect } from 'react';
import { motion } from 'framer-motion';

export const EASE = [0.16, 1, 0.3, 1];

/* Inject a platform embed script once (TikTok / Instagram) */
export function useEmbedScript(src, flag) {
  useEffect(() => {
    if (window[flag]) return;
    window[flag] = true;
    const s = document.createElement('script');
    s.src = src;
    s.async = true;
    document.body.appendChild(s);
  }, []);
}

/* Below-the-fold scroll reveal */
export function Reveal({ children, delay = 0, y = 30, className = '', ...rest }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.8, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

/* Masked line-by-line reveal — the signature on-load moment */
export function MaskedLine({ children, delay = 0, className = '' }) {
  return (
    <span className={`block overflow-hidden pb-[0.06em] ${className}`}>
      <motion.span
        className="block will-change-transform"
        initial={{ y: '112%' }}
        animate={{ y: '0%' }}
        transition={{ duration: 0.95, ease: EASE, delay }}
      >
        {children}
      </motion.span>
    </span>
  );
}

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  render() {
    if (this.state.err) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-plum text-ivory">
          <p className="font-mono text-sm tracking-widest">SOMETHING SKIPPED — REFRESH THE TRACK</p>
        </div>
      );
    }
    return this.props.children;
  }
}
